import React, {useCallback, useEffect, useRef, useState} from 'react'
import {loadFacebookPagesCompleted, loadFacebookPagesFailed, loadFacebookPagesStarted} from "../../../../actions/pages";
import axios from "axios";
import {requestFacebookPages} from "../../../../actions/requests";
import {useDispatch} from "react-redux";
import PagesSelection from "../../../UI/PagesSelection";
import {CSRF} from "../../../../constants";
import {addFacebookPagesToUser, incUserPagesCount} from "../../../../actions/user";
import {errorNotify} from "../../../../utils/app";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const Exporter = (props) => {
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const btnRef = useRef()
    const exportForm = useRef()
    const [selectedPage, setSelectedPage] = useState({name: "Select a page"})
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
    const [showIcon, setShowIcon] = useState(false)

    useEffect(()=>{
        setLoad(true)
        dispatch(requestFacebookPages(setLoad, false))
    },[])

    useEffect(() => {
        isValidForm()
    }, [selectedPage])


    const handleInputChange = (e) => {
        e.preventDefault()
        setSelectedPage({name: e.currentTarget.innerText, uuid: e.currentTarget.value, type: e.currentTarget.getAttribute("data-type")})
    }

    const isValidForm = useCallback(() => {
        const formData = new FormData(exportForm.current);
        let valid = true

        for (let [key, value] of formData.entries()) {
            if (!value || value.trim() === '') {
                valid = false
                break
            }
        }
        const isPageSelected = selectedPage.hasOwnProperty('uuid');
        btnRef.current.disabled = !(valid && isPageSelected);
    }, [exportForm, btnRef, selectedPage])



    const handleExportForm = (e) => {
        e.preventDefault()
        const formData = new FormData(exportForm.current)

        axios({
            method: 'post',
            url: `/tools/create_export`,
            data: formData,
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': CSRF
            }
        }).then(response => {
            setShowIcon(true)
            setTimeout(() => setShowIcon(false), 2000)
            exportForm.current.reset()
            setSelectedPage({name: "Select a page"})
        }).catch(errors => {
                console.log("errors", errors)
            }
        )
    }

    return (
        <div>
            <div className="my-4">
                Use the comment exporter to generate and download CSV file of your comments.
            </div>

            <div className="pb-3 mt-2" >
                <form onSubmit={handleExportForm} ref={exportForm}>
                    <div className="col-lg-6 mt-4 mb-3 px-0">
                        <PagesSelection handleInputChange={handleInputChange}
                                        load={load}
                                        pageName={selectedPage.name}
                                        pageType={selectedPage.type}
                                        noIcon={selectedPage.uuid ? false : true}
                        />
                        {selectedPage.uuid && <input type="hidden" name="page_uuid" value={selectedPage.uuid}/>}

                        <div className="form-group mb-2 mt-3">
                            <label>URL</label>

                            <div className="nrt mb-2">
                                <span className="mr-4">Enter the URL of your post or ad</span>
                                <a href="https://help.commentguard.io/article/150-how-to-use-our-comment-export-tools"
                                   className="g-link"
                                   target="_blank">
                                    Not sure how to find the correct URL?
                                </a>
                            </div>


                            <input type="text" name="url"
                                   className="form-control"
                                   onChange={isValidForm}/>

                        </div>

                        <div className="mb-4">
                            <input className="form-check-input" type="checkbox" name="nested_comments" value="true"/>
                            <label className="mx-2 fs-08">Include nested comments</label>
                        </div>

                        <div className="mb-3 fs-08">You will receive a link to download the export via email.</div>

                        <div className="row mt-4">
                            <div>
                                <button type="submit" className="btn btn-primary" ref={btnRef} disabled={true}>
                                    Export {showIcon && <FontAwesomeIcon icon={faCheck} className="ms-2" />}
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>

        </div>
    )
}

export default React.memo(Exporter)